import ListingPageContainer from './containers/ListingPageContainer'

export default ListingPageContainer
